import React from 'react'
import "./subHeader.css"
function subHeader({title}) {
  return (
    <div className="sub_header">
        <div className = "bar"></div>
      <h3>{title}</h3>   
    </div>
  )
}

export default subHeader